<template lang="pug">
  SaveLeadForm
</template>

<script>
import SaveLeadForm from '../Common/SaveLeadForm.vue';

export default {
  name: 'StepOne',
  data() {
    return {};
  },
  components: {
    SaveLeadForm,
  },
};
</script>
